















import { defineComponent } from '@vue/composition-api'
import InputSelect from '@/components/Inputs/InputSelect.vue'

// prettier-ignore
const SELECT_REGIONS = [
  { value: 'Москва', name: 'Москва' },
  { value: 'Московская область', name: 'Московская область' },
  { value: 'Адыгея Республика', name: 'Адыгея Республика' },
  { value: 'Башкортостан Республика', name: 'Башкортостан Республика' },
  { value: 'Бурятия Республика', name: 'Бурятия Республика' },
  { value: 'Алтай Республика', name: 'Алтай Республика' },
  { value: 'Дагестан Республика', name: 'Дагестан Республика' },
  { value: 'Ингушетия Республика', name: 'Ингушетия Республика' },
  { value: 'Кабардино-Балкарская Республика', name: 'Кабардино-Балкарская Республика', },
  { value: 'Калмыкия Республика', name: 'Калмыкия Республика' },
  { value: 'Карачаево-Черкесская Республика', name: 'Карачаево-Черкесская Республика', },
  { value: 'Карелия Республика', name: 'Карелия Республика' },
  { value: 'Коми Республика', name: 'Коми Республика' },
  { value: 'Марий Эл Республика', name: 'Марий Эл Республика' },
  { value: 'Мордовия Республика', name: 'Мордовия Республика' },
  { value: 'Саха (Якутия) Республика', name: 'Саха (Якутия) Республика' },
  { value: 'Северная Осетия - Алания Республика', name: 'Северная Осетия - Алания Республика', },
  { value: 'Татарстан Республика', name: 'Татарстан Республика' },
  { value: 'Тыва Республика', name: 'Тыва Республика' },
  { value: 'Удмуртская Республика', name: 'Удмуртская Республика' },
  { value: 'Хакасия Республика', name: 'Хакасия Республика' },
  { value: 'Чеченская Республика', name: 'Чеченская Республика' },
  { value: 'Чувашская Республика - Чувашия', name: 'Чувашская Республика - Чувашия', },
  { value: 'Алтайский Край', name: 'Алтайский Край' },
  { value: 'Краснодарский Край', name: 'Краснодарский Край' },
  { value: 'Красноярский Край', name: 'Красноярский Край' },
  { value: 'Приморский Край', name: 'Приморский Край' },
  { value: 'Ставропольский Край', name: 'Ставропольский Край' },
  { value: 'Хабаровский Край', name: 'Хабаровский Край' },
  { value: 'Амурская Область', name: 'Амурская Область' },
  { value: 'Архангельская Область', name: 'Архангельская Область' },
  { value: 'Астраханская Область', name: 'Астраханская Область' },
  { value: 'Белгородская Область', name: 'Белгородская Область' },
  { value: 'Брянская Область', name: 'Брянская Область' },
  { value: 'Владимирская Область', name: 'Владимирская Область' },
  { value: 'Волгоградская Область', name: 'Волгоградская Область' },
  { value: 'Вологодская Область', name: 'Вологодская Область' },
  { value: 'Воронежская Область', name: 'Воронежская Область' },
  { value: 'Ивановская Область', name: 'Ивановская Область' },
  { value: 'Иркутская Область', name: 'Иркутская Область' },
  { value: 'Калининградская Область', name: 'Калининградская Область' },
  { value: 'Калужская Область', name: 'Калужская Область' },
  { value: 'Камчатский Край', name: 'Камчатский Край' },
  { value: 'Кемеровская область - Кузбасс Область', name: 'Кемеровская область - Кузбасс Область', },
  { value: 'Кировская Область', name: 'Кировская Область' },
  { value: 'Костромская Область', name: 'Костромская Область' },
  { value: 'Курганская Область', name: 'Курганская Область' },
  { value: 'Курская Область', name: 'Курская Область' },
  { value: 'Ленинградская Область', name: 'Ленинградская Область' },
  { value: 'Липецкая Область', name: 'Липецкая Область' },
  { value: 'Магаданская Область', name: 'Магаданская Область' },
  { value: 'Мурманская Область', name: 'Мурманская Область' },
  { value: 'Нижегородская Область', name: 'Нижегородская Область' },
  { value: 'Новгородская Область', name: 'Новгородская Область' },
  { value: 'Новосибирская Область', name: 'Новосибирская Область' },
  { value: 'Омская Область', name: 'Омская Область' },
  { value: 'Оренбургская Область', name: 'Оренбургская Область' },
  { value: 'Орловская Область', name: 'Орловская Область' },
  { value: 'Пензенская Область', name: 'Пензенская Область' },
  { value: 'Пермский Край', name: 'Пермский Край' },
  { value: 'Псковская Область', name: 'Псковская Область' },
  { value: 'Ростовская Область', name: 'Ростовская Область' },
  { value: 'Рязанская Область', name: 'Рязанская Область' },
  { value: 'Самарская Область', name: 'Самарская Область' },
  { value: 'Саратовская Область', name: 'Саратовская Область' },
  { value: 'Сахалинская Область', name: 'Сахалинская Область' },
  { value: 'Свердловская Область', name: 'Свердловская Область' },
  { value: 'Смоленская Область', name: 'Смоленская Область' },
  { value: 'Тамбовская Область', name: 'Тамбовская Область' },
  { value: 'Тверская Область', name: 'Тверская Область' },
  { value: 'Томская Область', name: 'Томская Область' },
  { value: 'Тульская Область', name: 'Тульская Область' },
  { value: 'Тюменская Область', name: 'Тюменская Область' },
  { value: 'Ульяновская Область', name: 'Ульяновская Область' },
  { value: 'Челябинская Область', name: 'Челябинская Область' },
  { value: 'Забайкальский Край', name: 'Забайкальский Край' },
  { value: 'Ярославская Область', name: 'Ярославская Область' },
  { value: 'Санкт-Петербург', name: 'Санкт-Петербург' },
  { value: 'Еврейская Автономная область', name: 'Еврейская Автономная область', },
  { value: 'Ненецкий Автономный округ', name: 'Ненецкий Автономный округ' },
  { value: 'Ханты-Мансийский Автономный округ - Югра Автономный округ', name: 'Ханты-Мансийский Автономный округ - Югра Автономный округ', },
  { value: 'Чукотский Автономный округ', name: 'Чукотский Автономный округ' },
  { value: 'Ямало-Ненецкий Автономный округ', name: 'Ямало-Ненецкий Автономный округ', },
  { value: 'Запорожская Область', name: 'Запорожская Область' },
  { value: 'Крым Республика', name: 'Крым Республика' },
  { value: 'Севастополь', name: 'Севастополь' },
  { value: 'Донецкая Народная Республика', name: 'Донецкая Народная Республика', },
  { value: 'Луганская Народная Республика', name: 'Луганская Народная Республика', },
  { value: 'Херсонская Область', name: 'Херсонская Область' },
  { value: 'Байконур', name: 'Байконур' },
]

export default defineComponent({
  name: 'InputSelectRegion',
  components: {
    InputSelect,
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Object],
      default: '',
    },
    error: {
      type: [String, Boolean],
      default: false,
    },
    isNewStyle: {
      default: false,
    },
  },
  setup() {
    return {
      SELECT_REGIONS,
    }
  },
})
